module.exports = "<company-page></company-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/company.html
// module id = 1344
// module chunks = 0